module.exports = __webpack_public_path__ + "static/media/connect.e62cf642.jpg";